import styled from "styled-components";

interface iButtonProps {
  isVisible: boolean;
  color: string;
  backgroundColor?: string;
  borderRadius?: string;
}

export const Container = styled.a<iButtonProps>`
      opacity: ${props => props.isVisible ? 1 : 0};
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: ${props => props.color  || '#856D55'};
      background-color:  ${props => props.backgroundColor  || '#ffff'};
      z-index: 2;
      position: fixed; 
      padding: 5px 10px;
      border: ${props => '1px solid '+props.color || '1px solid #856D55'};     
      transition: opacity 1s;
      font-size: 0.75rem;
      transition: all 1s;
      bottom: 110px;
      right: 3.5%;
      border-radius: ${props => props.borderRadius  || '0px'};
      @media (min-width: 768px) {
        right: 3%;
        
  }

      .iconSvg{
        background-color: transparent;
        width: 20px; 
        height: 20px; 
        transition: all 1s;
        path{
          fill: ${props =>  props.color || '#856D55'};
          transition: all 1s;
        }       
      }

      :hover{
        background-color: ${props => props.color || props.theme.colors.neutral2.pure};
        color: white;
        border: ${props =>  '1px solid black '+ props.color || '1px solid'+ props.theme.colors.neutral2.pure};
        .iconSvg{
          background-color:transparent;
          color: ${props => props.theme.colors.typography1.pure};
          path{
            fill: ${props => props.theme.colors.neutral1.pure};
          }
        }
      }
`
